module.exports = __webpack_public_path__ + "8577fc06abb0ce6fba7e7ae6c1004a72.png";